// src/router/index.ts
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import { useModulos } from '@/composables/useModulos'
import type { ModuloId } from '@/utils/modulos'

const Layout = () => import(/* webpackChunkName: "layout" */ '@/components/Layout.vue')
const LoginPage = () => import(/* webpackChunkName: "page-login" */ '@/pages/LoginPage.vue')
const DashboardPage = () => import(/* webpackChunkName: "page-dashboard" */ '@/pages/DashboardPage.vue')
const EstructurasPage = () => import(/* webpackChunkName: "page-estructuras" */ '@/pages/EstructurasPage.vue')
const InventarioPage = () => import(/* webpackChunkName: "page-inventario" */ '@/pages/InventarioPage.vue')
const TrasladoAvesPage = () => import(/* webpackChunkName: "page-traslados" */ '@/pages/TrasladoAvesPage.vue')
const DatosPage = () => import(/* webpackChunkName: "page-datos" */ '@/pages/DatosPage.vue')
const ResumenSemanalPage = () => import(/* webpackChunkName: "page-resumen-semanal" */ '@/pages/ResumenSemanalPage.vue')
const ClientesPage = () => import(/* webpackChunkName: "page-admin-clientes" */ '@/pages/admin/ClientesPage.vue')
const LicenciasPage = () => import(/* webpackChunkName: "page-admin-licencias" */ '@/pages/admin/LicenciasPage.vue')
// Módulo Plan/Facturación + Pagos deshabilitado del build (archivos aún no commiteados).
// const PagosAdminPage = () => import(/* webpackChunkName: "page-admin-pagos" */ '@/pages/admin/PagosAdminPage.vue')
const FormulariosPage = () => import(/* webpackChunkName: "page-formularios" */ '@/pages/FormulariosPage.vue')
const LogsPage = () => import(/* webpackChunkName: "page-logs" */ '@/pages/LogsPage.vue')
const ReconciliacionPage = () => import(/* webpackChunkName: "page-reconciliacion" */ '@/pages/ReconciliacionPage.vue')
// const PlanFacturacionPage = () => import(/* webpackChunkName: "page-plan" */ '@/pages/PlanFacturacionPage.vue')
const SolicitudesEliminacionPage = () => import(/* webpackChunkName: "page-delete-requests" */ '@/pages/SolicitudesEliminacionPage.vue')
const AlimentoFormPage = () => import(/* webpackChunkName: "form-alimento" */ '@/pages/forms/AlimentoFormPage.vue')
const CostosFormPage = () => import(/* webpackChunkName: "form-costos" */ '@/pages/forms/CostosFormPage.vue')
const ManejoFormPage = () => import(/* webpackChunkName: "form-manejos" */ '@/pages/forms/ManejoFormPage.vue')
const DescripcionGeneralFormPage = () => import(/* webpackChunkName: "form-descripcion-general" */ '@/pages/forms/DescripcionGeneralFormPage.vue')
const RegistroDiarioFormPage = () => import(/* webpackChunkName: "form-registro-diario" */ '@/pages/forms/RegistroDiarioFormPage.vue')
const RegistroPesosFormPage = () => import(/* webpackChunkName: "form-registro-pesos" */ '@/pages/forms/RegistroPesosFormPage.vue')
const CierreCicloFormPage = () => import(/* webpackChunkName: "form-cierre-ciclo" */ '@/pages/forms/CierreCicloFormPage.vue')
const VentaHuevoFormPage = () => import(/* webpackChunkName: "form-venta-huevo" */ '@/pages/forms/VentaHuevoFormPage.vue')
const EngordeHomePage = () => import(/* webpackChunkName: "page-engorde" */ '@/pages/engorde/EngordeHomePage.vue')
const CiclosPage = () => import(/* webpackChunkName: "page-engorde-ciclos" */ '@/pages/engorde/CiclosPage.vue')
const EncasetamientoFormPage = () => import(/* webpackChunkName: "form-encasetamiento" */ '@/pages/engorde/EncasetamientoFormPage.vue')
const GuiaEstandarPage = () => import(/* webpackChunkName: "page-engorde-guia" */ '@/pages/engorde/GuiaEstandarPage.vue')
const RegistroDiarioEngordeFormPage = () => import(/* webpackChunkName: "form-engorde-diario" */ '@/pages/engorde/RegistroDiarioEngordeFormPage.vue')
const PesajeEngordeFormPage = () => import(/* webpackChunkName: "form-engorde-pesaje" */ '@/pages/engorde/PesajeEngordeFormPage.vue')
const CierreEngordeFormPage = () => import(/* webpackChunkName: "form-engorde-cierre" */ '@/pages/engorde/CierreEngordeFormPage.vue')
const CierreBloquePage = () => import(/* webpackChunkName: "form-engorde-cierre-bloque" */ '@/pages/engorde/CierreBloquePage.vue')
const SacadaPage = () => import(/* webpackChunkName: "form-engorde-sacada" */ '@/pages/engorde/SacadaPage.vue')
const InventarioEngordePage = () => import(/* webpackChunkName: "page-engorde-inventario" */ '@/pages/engorde/InventarioEngordePage.vue')
const MortalidadDiariaPage = () => import(/* webpackChunkName: "page-engorde-mortalidad" */ '@/pages/engorde/MortalidadDiariaPage.vue')
const ResumenSemanalEngordePage = () => import(/* webpackChunkName: "page-engorde-semanal" */ '@/pages/engorde/ResumenSemanalEngordePage.vue')
const PresupuestoEngordePage = () => import(/* webpackChunkName: "page-engorde-presupuesto" */ '@/pages/engorde/PresupuestoEngordePage.vue')
const PedidoInsumosPage = () => import(/* webpackChunkName: "form-engorde-insumos" */ '@/pages/engorde/PedidoInsumosPage.vue')
const LoteFichaPage = () => import(/* webpackChunkName: "page-engorde-lote" */ '@/pages/engorde/LoteFichaPage.vue')
const PlanEncasetamientoPage = () => import(/* webpackChunkName: "page-engorde-plan" */ '@/pages/engorde/PlanEncasetamientoPage.vue')
const LlegadasPage = () => import(/* webpackChunkName: "page-engorde-llegadas" */ '@/pages/engorde/LlegadasPage.vue')
const DatosEngordePage = () => import(/* webpackChunkName: "page-engorde-datos" */ '@/pages/engorde/DatosEngordePage.vue')
const CalendarioPage = () => import(/* webpackChunkName: "page-engorde-calendario" */ '@/pages/engorde/CalendarioPage.vue')
const EngordeFormulariosPage = () => import(/* webpackChunkName: "page-engorde-formularios" */ '@/pages/engorde/EngordeFormulariosPage.vue')

// Las rutas sin `modulo` son comunes a todos los módulos (estructuras, inventario,
// logs, solicitudes, admin). Las que lo declaran solo abren si el cliente lo tiene
// habilitado; el bloqueo real está en la policy del backend.

// Definir rutas con el tipo RouteRecordRaw
const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    alias: ['/'],
    name: 'Login',
    component: LoginPage,
    meta: { requiresAuth: false, title: 'Iniciar sesión' }
  },
  {
    path: '/dashboard',
    component: Layout,
    meta: { requiresAuth: true, modulo: 'postura', roles: ['superadmin', 'admin', 'supervisor', 'operario'] },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: DashboardPage,
        meta: { title: 'Panel' },
      }
    ]
  },
  {
    path: '/estructuras',
    component: Layout,
    meta: { requiresAuth: true, roles: ['superadmin', 'admin', 'supervisor'] },
    children: [
      {
        path: '',
        name: 'Estructuras',
        component: EstructurasPage,
        meta: { title: 'Estructuras' },
      }
    ]
  },
  {
    path: '/inventario',
    component: Layout,
    meta: { requiresAuth: true, roles: ['superadmin', 'admin', 'supervisor', 'operario'] },
    children: [
      {
        path: '',
        name: 'Inventario',
        component: InventarioPage,
        meta: { title: 'Inventario de insumos' },
      },
    ],
  },
  {
    // Común a postura y engorde: los usuarios son del cliente, no de un módulo.
    path: '/usuarios',
    component: Layout,
    meta: { requiresAuth: true, roles: ['superadmin', 'admin'] },
    children: [
      {
        path: '',
        name: 'Usuarios',
        component: () => import(/* webpackChunkName: "page-usuarios" */ '@/pages/UsuariosPage.vue'),
        meta: { title: 'Usuarios' },
      },
    ],
  },
  {
    path: '/traslados',
    component: Layout,
    meta: { requiresAuth: true, roles: ['superadmin', 'admin'] },
    children: [
      {
        path: '',
        name: 'TrasladoAves',
        component: TrasladoAvesPage,
        meta: { title: 'Traslados' },
      },
    ],
  },
  {
    path: '/datos',
    component: Layout,
    meta: { requiresAuth: true, modulo: 'postura', roles: ['superadmin', 'admin', 'supervisor', 'operario'] },
    children: [
      {
        path: '',
        name: 'Datos',
        component: DatosPage,
        meta: { title: 'Datos registrados' },
      },
    ],
  },
  {
    path: '/resumen-semanal',
    component: Layout,
    meta: { requiresAuth: true, modulo: 'postura', roles: ['superadmin', 'admin', 'supervisor', 'operario'] },
    children: [
      {
        path: '',
        name: 'ResumenSemanal',
        component: ResumenSemanalPage,
        meta: { title: 'Resumen semanal' },
      },
    ],
  },
  {
    path: '/admin',
    component: Layout,
    meta: { requiresAuth: true, roles: ['superadmin'] },
    children: [
      {
        path: 'clientes',
        name: 'AdminClientes',
        component: ClientesPage,
        meta: { title: 'Clientes' },
      },
      {
        path: 'licencias',
        name: 'AdminLicencias',
        component: LicenciasPage,
        meta: { title: 'Licencias' },
      },
    ],
  },
  {
    path: '/formularios',
    component: Layout,
    meta: { requiresAuth: true, modulo: 'postura' },
    children: [
      {
        path: '',
        name: 'Formularios',
        component: FormulariosPage,
        meta: { title: 'Formularios' },
      },
      {
        path: 'alimento',
        name: 'AlimentoForm',
        meta: { roles: ['superadmin', 'admin', 'supervisor', 'operario'], title: 'Consumo de alimento' },
        component: AlimentoFormPage,
      },
      {
        path: 'costos',
        name: 'CostosForm',
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Registro de costos' },
        component: CostosFormPage,
      },
      {
        path: 'manejos',
        name: 'ManejosForm',
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Cronograma de manejos' },
        component: ManejoFormPage,
      },
      {
        path: 'descripcion-general',
        name: 'DescripcionGeneralForm',
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Inicio del galpón' },
        component: DescripcionGeneralFormPage,
      },
      {
        path: 'cierre-ciclo',
        name: 'CierreCicloForm',
        // Sin operario: el cierre congela el ciclo y bloquea su edición.
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Cierre de ciclo' },
        component: CierreCicloFormPage,
      },
      {
        path: 'ventas-huevo',
        name: 'VentaHuevoForm',
        meta: { roles: ['superadmin', 'admin', 'supervisor', 'operario'], title: 'Ventas de huevo' },
        component: VentaHuevoFormPage,
      },
      {
        path: 'registro-diario',
        name: 'RegistroDiarioForm',
        meta: { roles: ['superadmin', 'admin', 'supervisor', 'operario'], title: 'Registro diario' },
        component: RegistroDiarioFormPage,
      },
      {
        path: 'registro-pesos',
        name: 'RegistroPesosForm',
        meta: { roles: ['superadmin', 'admin', 'supervisor', 'operario'], title: 'Registro de pesos' },
        component: RegistroPesosFormPage,
      }
    ]
  },
  {
    path: '/logs',
    component: Layout,
    meta: { requiresAuth: true, roles: ['superadmin', 'admin', 'supervisor'] },
    children: [
      {
        path: '',
        name: 'Logs',
        component: LogsPage,
        meta: { title: 'Logs' },
      }
    ]
  },
  {
    path: '/reconciliacion',
    component: Layout,
    meta: { requiresAuth: true, modulo: 'postura', roles: ['superadmin'] },
    children: [
      {
        path: '',
        name: 'Reconciliacion',
        component: ReconciliacionPage,
        meta: { title: 'Reconciliación de aves' },
      }
    ]
  },
  {
    path: '/solicitudes-eliminacion',
    component: Layout,
    meta: { requiresAuth: true, roles: ['superadmin', 'admin', 'supervisor', 'operario'] },
    children: [
      {
        path: '',
        name: 'SolicitudesEliminacion',
        component: SolicitudesEliminacionPage,
        meta: { title: 'Solicitudes de eliminación' },
      }
    ]
  },
  {
    path: '/engorde',
    component: Layout,
    meta: { requiresAuth: true, modulo: 'engorde', roles: ['superadmin', 'admin', 'supervisor', 'operario'] },
    children: [
      {
        path: '',
        name: 'EngordeHome',
        component: EngordeHomePage,
        meta: { title: 'Pollos de engorde' },
      },
      {
        path: 'formularios',
        name: 'EngordeFormularios',
        component: EngordeFormulariosPage,
        meta: { roles: ['superadmin', 'admin', 'supervisor', 'operario'], title: 'Registros de granja' },
      },
      {
        path: 'lote/:id',
        name: 'EngordeLote',
        component: LoteFichaPage,
        meta: { roles: ['superadmin', 'admin', 'supervisor', 'operario'], title: 'Ficha del lote', modulo: 'engorde' },
      },
      {
        // La proyección se fusionó con el plan de encasetamiento: los enlaces
        // viejos van a los planes guardados.
        path: 'proyeccion',
        name: 'EngordeProyeccion',
        redirect: { name: 'EngordePlan', query: { vista: 'guardados' } },
      },
      {
        path: 'plan',
        name: 'EngordePlan',
        component: PlanEncasetamientoPage,
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Plan de encasetamiento' },
      },
      {
        path: 'calendario',
        name: 'EngordeCalendario',
        component: CalendarioPage,
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Calendario de galpones' },
      },
      {
        path: 'llegadas',
        name: 'EngordeLlegadas',
        component: LlegadasPage,
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Llegadas previstas' },
      },
      {
        path: 'datos',
        name: 'EngordeDatos',
        component: DatosEngordePage,
        meta: {
          roles: ['superadmin', 'admin', 'supervisor', 'operario'],
          title: 'Datos de engorde',
        },
      },
      // Los lotes cerrados dejaron de tener pantalla propia: eran los mismos que
      // «Datos → Por lote» con el filtro de estado en «Cerrados», que ya existía.
      // Se mantiene la ruta como redirección para no romper enlaces guardados.
      {
        path: 'cerrados',
        redirect: { name: 'EngordeDatos', query: { estado: 'cerrado' } },
      },
      {
        path: 'ciclos',
        name: 'EngordeCiclos',
        component: CiclosPage,
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Ciclos' },
      },
      {
        path: 'encasetamiento',
        name: 'EngordeEncasetamiento',
        component: EncasetamientoFormPage,
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Encasetamiento' },
      },
      {
        path: 'registro-diario',
        name: 'EngordeRegistroDiario',
        component: RegistroDiarioEngordeFormPage,
        meta: { roles: ['superadmin', 'admin', 'supervisor', 'operario'], title: 'Registro diario' },
      },
      {
        path: 'pesaje',
        name: 'EngordePesaje',
        component: PesajeEngordeFormPage,
        meta: { roles: ['superadmin', 'admin', 'supervisor', 'operario'], title: 'Pesaje' },
      },
      {
        path: 'cierre',
        name: 'EngordeCierre',
        component: CierreEngordeFormPage,
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Cierre del lote' },
      },
      {
        // Mismos roles que el cierre de a uno: hace lo mismo, solo que varias
        // veces. Dar permisos distintos a las dos puertas de la misma acción
        // sería una diferencia que nadie podría explicar.
        path: 'cierre-bloque',
        name: 'EngordeCierreBloque',
        component: CierreBloquePage,
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Cierre en bloque' },
      },
      {
        // Tablero de inventario: todas las granjas, hoy y los días que vienen.
        path: 'inventario',
        name: 'EngordeInventario',
        component: InventarioEngordePage,
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Inventario y sacada' },
      },
      {
        // Indicador diario de mortalidad: bajas sobre el saldo del día anterior.
        path: 'mortalidad',
        name: 'EngordeMortalidad',
        component: MortalidadDiariaPage,
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Mortalidad diaria' },
      },
      {
        // Todos los lotes abiertos en su semana de vida, contra la tabla.
        path: 'semanal',
        name: 'EngordeSemanal',
        component: ResumenSemanalEngordePage,
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Resumen semanal' },
      },
      {
        // Aves y kilos que salen a planta cada mes, para el presupuesto.
        path: 'presupuesto',
        name: 'EngordePresupuesto',
        component: PresupuestoEngordePage,
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Presupuesto mensual' },
      },
      {
        // Quien programa la sacada (supervisor o administrador) también registra
        // la remisión y lo que recibió la planta.
        path: 'sacada',
        name: 'EngordeSacada',
        component: SacadaPage,
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Programación de sacada' },
      },
      {
        path: 'insumos',
        name: 'EngordeInsumos',
        component: PedidoInsumosPage,
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Pedido de insumos' },
      },
      {
        path: 'guia',
        name: 'EngordeGuia',
        component: GuiaEstandarPage,
        meta: { roles: ['superadmin', 'admin', 'supervisor'], title: 'Guía estándar' },
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory('/'),  // Usamos '/' como ruta base
  routes
})

// Guardia de navegación
router.beforeEach((to, from, next) => {
  const auth = useAuthStore()
  const { rutaInicio, puedeAccederModulo, modulos, setModuloActivo } = useModulos()

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    next({ name: 'Login' })
    return
  }

  if (to.name === 'Login' && auth.isAuthenticated) {
    next(rutaInicio.value)
    return
  }

  const roles = (to.meta as { roles?: string[] }).roles
  if (roles && roles.length > 0) {
    const currentRole = auth.user?.role
    if (!currentRole || !roles.includes(currentRole)) {
      next(rutaInicio.value)
      return
    }
  }

  const modulo = (to.meta as { modulo?: ModuloId }).modulo
  if (to.meta.requiresAuth && !puedeAccederModulo(modulo)) {
    // Del módulo que el cliente SÍ tiene, pero no es el activo: se cambia el
    // activo y se deja pasar. Abrir una url de engorde estando en postura es una
    // intención clara, y rebotarla dejaba la app en un estado incoherente — la
    // página cargaba igual (en recarga completa el guard aún no sabe el cliente)
    // y a partir de ahí cada enlace saltaba al inicio sin explicar por qué.
    // Sigue habiendo un solo módulo activo a la vez, que es lo que se quería.
    if (modulo && modulos.value.includes(modulo)) {
      setModuloActivo(modulo)
      next()
      return
    }

    // Del módulo que no tiene contratado: a lo suyo.
    next(rutaInicio.value)
    return
  }

  next()
})

// Título de la pestaña por ruta: con varias pestañas abiertas se distinguen entre sí.
router.afterEach((to, _from, failure) => {
  // afterEach tambien corre cuando la navegacion se aborta: al elegir "seguir
  // editando" en cambios sin guardar, te quedas en el formulario pero la pestaña
  // pasaba a anunciar la pantalla a la que no fuiste. Con varias pestañas
  // abiertas, que es justo para lo que sirve el titulo, eso confunde.
  if (failure) return
  const title = (to.meta as { title?: string }).title
  document.title = title ? `${title} · VIVAZ` : 'VIVAZ'
})

export default router
